import { animate, style, transition, trigger, group } from '@angular/animations';

export const FOLD_OUT_ANIMATION = trigger('collapsible', [
  transition(':enter', [
    style({
      height: '0px',
      'min-height': '0',
      'padding-top': '0',
      'padding-bottom': '0',
      'margin-top': '0',
      'margin-bottom': '0',
      opacity: 1
    }),
    group([
      animate('100ms', style({ opacity: 1 })),
      animate(
        '250ms ease',
        style({
          height: '*',
          'min-height': '*',
          'padding-top': '*',
          'padding-bottom': '*',
          'margin-top': '*',
          'margin-bottom': '*'
        })
      )
      // firefox breaks on padding * margin * directives, use explicit Top/Bottom
    ])
  ]),
  transition(':leave', [
    style({
      'min-height': '*',
      'padding-top': '*',
      'padding-bottom': '*',
      'margin-top': '*',
      'margin-bottom': '*'
    }),
    group([
      animate('100ms 150ms', style({ opacity: 0 })),
      animate(
        '250ms ease',
        style({
          height: 0,
          'min-height': 0,
          'padding-top': 0,
          'padding-bottom': 0,
          'margin-top': 0,
          'margin-bottom': 0
        })
      )
      // firefox breaks on padding * margin * directives, use explicit Top/Bottom
    ])
  ])
]);
